import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

import { appConfig } from '@/config.js'
import { shouldIgnoreSentryAxiosError } from '@/services/telemetry/shouldIgnoreSentryAxiosError'

export function initSentry({ app, router }: { app: App; router: Router }): void {
    const dsn = import.meta.env.VITE_SENTRY_DSN

    if (!dsn) {
        return
    }

    const tracesSampleRate = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as number
    const replaysSessionSampleRate = import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE as number
    const replaysOnErrorSampleRate = import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE as number

    const tracePropagationTargets: Array<string | RegExp> = [new URL(import.meta.env.VITE_APP_FACTORYBASE_API_URI).origin]

    Sentry.init({
        app,
        dsn,
        sendDefaultPii: true,
        tracesSampleRate,
        replaysSessionSampleRate,
        replaysOnErrorSampleRate,
        enableLogs: true,
        normalizeDepth: 10,
        tracePropagationTargets,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false
            })
        ],
        environment: import.meta.env.VITE_APP_MODE,
        release: appConfig?.common?.appVersion || 'unknown',
        ignoreErrors: ['Network Error'],
        beforeSend(event, hint) {
            if (shouldIgnoreSentryAxiosError(hint.originalException)) {
                return null
            }

            return event
        }
    })
}
